// extracted by mini-css-extract-plugin
export var required = "_dr-0";